import { FaNodeJs, FaReact, FaCss3, FaHtml5, FaJava } from 'react-icons/fa'
import { DiGitBranch, DiScrum, } from 'react-icons/di'
import { SiAngular, SiMicrosoftsqlserver, SiPostgresql, SiSpring } from 'react-icons/si'

import {GrDocker} from 'react-icons/gr'
const data = [

  {
    id: 1,
    image: <FaNodeJs />,
    title: 'NodeJS',
    domaine: 'Backend'
   
  },
  {
    id: 2,
    image: <FaHtml5 />,
    title: 'HTML5',
    domaine: 'Frontend'
   
  },
  {
    id: 3,
    image: <GrDocker />,
    title: 'Docker',
    domaine: 'Outil'
  },
  {
    id: 4,
    image: <FaReact />,
    title: 'React',
    domaine: 'Frontend'
  },
  {
    id: 5,
    image: <FaCss3 />,
    title: 'CSS3',
    domaine: 'Frontend'
  },
  {
    id: 6,
    image: <SiMicrosoftsqlserver />,
    title: 'SQL Server',
    domaine: 'Data'
   
  },
  {
    id: 7,
    image: <DiGitBranch />,
    title: 'Git',
    domaine: 'Outil'
   
  },
  {
    id: 8,
    image: <SiAngular />,
    title: 'Angular',
    domaine: 'Frontend'
  },
  {
    id: 9,
    image: <FaJava />,
    title: 'Java',
    domaine: 'Backend'
  },
  {
    id: 10,
    image: <SiSpring />,
    title: 'Spring',
    domaine: 'Backend'
  },
  {
    id: 11,
    image: <DiScrum />,
    title: 'Scrum',
    domaine: 'Outil'
  },
  {
    id: 12,
    image: <SiPostgresql/>,
    title: 'PostgreSQL',
    domaine: 'Data'
  },
]
export default data
